import {Box} from '@mui/material';
import ArrSelectableColumnChart, {
  TimelineType,
} from '../../../components/common/arr-selectable-column-chart/ArrSelectableColumnChart';
import {CustomMenuItem} from '../../../components/common/arr-menu/ArrMenu';
import {
  convertApiToChart,
  getDefaultActionMenuItems,
  getMockTimelineData,
} from '../../../components/common/arr-selectable-column-chart/chartUtils';
import {TIMELINE_COLOR_MAP} from '../../../shared/constants';

const SelectableColumnChart = () => {
  const apiResponse = getMockTimelineData();
  const monthYearLabel = new Date(
    apiResponse.dailyData[0].period
  ).toLocaleString('default', {month: 'long', year: 'numeric'});

  const {labels: yearlyLabels, series: yearlySeries} = convertApiToChart(
    apiResponse.yearlyData,
    'yearly'
  );
  const {labels: monthlyLabels, series: monthlySeries} = convertApiToChart(
    apiResponse.monthlyData,
    'monthly'
  );
  const {labels: dailyLabels, series: dailySeries} = convertApiToChart(
    apiResponse.dailyData,
    'daily'
  );

  const actionMenuItems = getDefaultActionMenuItems();

  const handleTimelineSelect = (info: {
    timelineType: TimelineType;
    barKey: string;
    label: string | string[];
    value: number;
  }) => {
    console.log('Timeline selection:', info);
  };

  const createActionHandler =
    (timelineType: TimelineType) => (item: CustomMenuItem) => {
      console.log(`Action "${item.id}" clicked on ${timelineType} timeline`);
    };

  const yearlyPeriodLabel =
    yearlyLabels.length > 1
      ? `${yearlyLabels[0]}-${yearlyLabels[yearlyLabels.length - 1]}`
      : yearlyLabels[0];

  return (
    <Box className="dashboard">
      <ArrSelectableColumnChart
        labels={yearlyLabels}
        series={yearlySeries}
        barColor={TIMELINE_COLOR_MAP.DefaultSeries}
        barActiveColor={TIMELINE_COLOR_MAP.Yearly}
        title={`Yearly Timeline: ${yearlyPeriodLabel}`}
        timelineType="yearly"
        onTimelineSelect={handleTimelineSelect}
        actionMenuItems={actionMenuItems}
        onActionPick={createActionHandler('yearly')}
      />
      <ArrSelectableColumnChart
        labels={monthlyLabels}
        series={monthlySeries}
        barColor={TIMELINE_COLOR_MAP.DefaultSeries}
        barActiveColor={TIMELINE_COLOR_MAP.Monthly}
        title="Monthly Timeline"
        timelineType="monthly"
        onTimelineSelect={handleTimelineSelect}
        actionMenuItems={actionMenuItems}
        onActionPick={createActionHandler('monthly')}
      />
      <ArrSelectableColumnChart
        labels={dailyLabels}
        series={dailySeries}
        barColor={TIMELINE_COLOR_MAP.DefaultSeries}
        barActiveColor={TIMELINE_COLOR_MAP.Daily}
        title="Daily Timeline"
        timelineType="daily"
        footerCaption={monthYearLabel}
        onTimelineSelect={handleTimelineSelect}
        actionMenuItems={actionMenuItems}
        onActionPick={createActionHandler('daily')}
      />
    </Box>
  );
};

export default SelectableColumnChart;
